module.exports = "<span [innerHTML]=\"output\"></span>\n<!-- {{input}} -->"